import { useMemo, useRef } from 'react';
import { useUser } from '../components/UserContext';
import { createApiClient } from "../components/useApiClient";
import { useSafeRequest } from "../components/useSafeRequest";
import { useIsAuthenticated } from "@azure/msal-react";
import { Note } from '../models/Note';

export const useNotesApi = () => {
    const { activeClientId, getAccessToken } = useUser();
    const isAuthenticated = useIsAuthenticated();
    const clientIdRef = useRef<number | null>(null);

    // Keep clientId ref updated
    clientIdRef.current = activeClientId;

    // Create API client
    const api = useMemo(
        () =>
            createApiClient(
                {
                    getAccessToken,
                    getClientId: () => clientIdRef.current
                },
                { timeoutMs: 12000 }
            ),
        [getAccessToken]
    );

    return { api, activeClientId, isAuthenticated };
};

// Individual safe request hooks for each endpoint
export const useNotesSafeRequests = (api: any) => {
    const getNotesReq = useSafeRequest<Note[]>(api, { maxAttempts: 3 });
    const getNoteReq = useSafeRequest<Note>(api, { maxAttempts: 3 });
    const createNoteReq = useSafeRequest<Note>(api, { maxAttempts: 3 });
    const updateNoteReq = useSafeRequest<Note>(api, { maxAttempts: 3 });
    const deleteNoteReq = useSafeRequest<void>(api, { maxAttempts: 3 });
    const getTagsReq = useSafeRequest<string[]>(api, { maxAttempts: 3 });
    const getTypesReq = useSafeRequest<string[]>(api, { maxAttempts: 3 });

    return {
        getNotesReq,
        getNoteReq,
        createNoteReq,
        updateNoteReq,
        deleteNoteReq,
        getTagsReq,
        getTypesReq
    };
};